export default __webpack_public_path__ + "static/image03-0edbc0ca8e1178cb5ec646de96ca8315.webp";